import React from 'react';
import { Table } from '@devexpress/dx-react-grid-bootstrap4';
import { useTranslation } from 'react-i18next';
import { GENERAL_ERROR_REPORT_MESSAGE, NO_DATA_TO_DISPLAY, AUTH_ERROR_MESSAGE } from '../../../i18n/keyConstants';

const NoDataRow = (isLoading, error, props) => {
    const colSpan = props.children.length;
    const { t } = useTranslation(['shared']);
    const msg = getDisplayMessage(error);

    function getDisplayMessage(error) {
        if (!error) return t(NO_DATA_TO_DISPLAY);

        switch (error.status) {
            case 401 || 403:
                return t(AUTH_ERROR_MESSAGE, { ns: 'errorMessages' });
            default:
                return t(GENERAL_ERROR_REPORT_MESSAGE, { ns: 'errorMessages' })
        }
    }

    return (
        <Table.Row>
            <td className='py-5 dx-g-bs4-no-data-cell' colSpan={colSpan}>
                {isLoading ? (
                    null
                ) : (
                    <div>
                        <big className='text-muted'>{msg}</big>
                    </div>
                )}
            </td>
        </Table.Row>
    );
};

export default NoDataRow;
